/**
 * On Range Driving Play Reducers
 */
import {
    ORTDRIVING_ACTION,
    ALL_ORTDRIVING,
    ADD_ORTDRIVING,
    FETCH_ORTDRIVING,
    EDIT_ORTDRIVING,
    DELETE_ORTDRIVING,
    FETCH_ORTDRIVINGCHART,
    FETCH_ORTDRIVINGSHOTCHART,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    ortdrivinglist:[],
    particularoratdriving:[], 
    ortdrivingchart:[],
    ortdrivingshotchart:[],   
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case ORTDRIVING_ACTION:
            return { ...state, loading: true };       

        case ALL_ORTDRIVING:
            return { ...state, loading: false, ortdrivinglist: action.payload };     
            
        case ADD_ORTDRIVING:
            return { ...state, loading: false };     
         
        case FETCH_ORTDRIVING:
            return { ...state, loading: false, particularoratdriving: action.payload };  
            
        case EDIT_ORTDRIVING:
            return { ...state, loading: false }; 
            
        case DELETE_ORTDRIVING:
            return { ...state, loading: false };     

        case FETCH_ORTDRIVINGCHART:
            return { ...state, loading: false, ortdrivingchart: action.payload };  
            
        case FETCH_ORTDRIVINGSHOTCHART:
            return { ...state, loading: false, ortdrivingshotchart: action.payload };  
        
        default: return { ...state };

     }
 }